module.exports = __webpack_public_path__ + "img/logo-total-gym.7f5892d.svg";